import React, { MouseEvent, useCallback } from "react";

import Tooltip from "antd/es/tooltip";

import { DataAttributesProps } from "@mapmycustomers/shared/types/dataAttributes";
import { Button, ButtonProps } from "@mapmycustomers/ui";

interface Props extends Omit<ButtonProps, "onClick" | "type">, DataAttributesProps {
  label: string;
  onClick?: () => void;
  tooltip?: string;
}

const AddOrCreateButton = ({
  className,
  dataAttributes,
  disabled,
  label,
  onClick,
  tooltip,
  ...buttonProps
}: Props) => {
  const handleClick = useCallback(
    (e: MouseEvent<HTMLElement>) => {
      e.stopPropagation(); // needed to prevent panel collapse
      onClick?.();
    },
    [onClick]
  );

  return (
    <Tooltip
      arrowPointAtCenter
      placement={disabled ? "topRight" : "top"}
      title={tooltip}
      trigger={disabled ? [] : ["hover"]}
    >
      <Button
        {...buttonProps}
        {...dataAttributes}
        className={className}
        data-id="add-or-create-button"
        disabled={disabled}
        onClick={handleClick}
        type="link"
      >
        {"+ "}
        {label}
      </Button>
    </Tooltip>
  );
};

export default AddOrCreateButton;
